import { useCallback, useState } from 'react'

// Used to catch asynchronous errors with ErrorBoundary.
export const useAsyncError = () => {
  const [_, setError] = useState()
  return useCallback(
    (e) => {
      setError(() => {
        throw e
      })
    },
    [setError]
  )
}
